module.exports = __webpack_public_path__ + "img/ic_wallet_normal.856e84de.svg";